module.exports = __webpack_public_path__ + "img/17.6544d6bd.jpg";